if ( typeof SquareSlider !== 'function' ) {

  class SquareSlider extends HTMLElement {

    connectedCallback() {
      if ( this._mounted ) return;
      this._mounted = true;

      if ( typeof Swiper === 'undefined' ) {
        // Swiper bundle is loaded with `defer`, so it may not be ready yet.
        // Retry shortly until the global is available.
        if ( this._retries === undefined ) this._retries = 0;
        if ( this._retries < 50 ) {
          this._retries++;
          this._mounted = false;
          setTimeout(() => this.connectedCallback(), 50);
        }
        return;
      }

      this.initSlider();
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    initSlider() {
      const container = this.querySelector('.swiper');
      if ( ! container ) return;

      let options = {};
      try {
        options = JSON.parse(this.dataset.options || '{}');
      } catch ( e ) {
        options = {};
      }

      const slideCount = this.querySelectorAll('.swiper-slide').length;

      // Disable loop when there aren't enough slides, otherwise Swiper warns
      // and the cloning behaves unexpectedly.
      if ( options.loop && slideCount < 3 ) {
        options.loop = false;
      }

      const config = {
        slidesPerView: options.slidesPerViewMobile || 1.2,
        spaceBetween: options.spaceBetweenMobile != null ? options.spaceBetweenMobile : 12,
        centeredSlides: true,
        loop: !!options.loop,
        speed: options.speed || 600,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          1024: {
            slidesPerView: options.slidesPerView || 1.4,
            spaceBetween: options.spaceBetween != null ? options.spaceBetween : 24
          }
        }
      };

      if ( options.autoplay ) {
        config.autoplay = {
          delay: options.autoplayDelay || 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }

      if ( options.arrows ) {
        config.navigation = {
          nextEl: this.querySelector('.square-slider__button--next'),
          prevEl: this.querySelector('.square-slider__button--prev')
        };
      }

      this.swiper = new Swiper(container, config);

      if ( options.pagination ) {
        this.initPagination();
      }
    }

    // Custom pagination keyed to the original slide count so that the
    // duplicated slides used for loop mode don't add extra bullets.
    initPagination() {
      const pag = this.querySelector('.square-slider__pagination');
      if ( ! pag || ! this.swiper ) return;

      const bullets = Array.from(pag.querySelectorAll('.swiper-pagination-bullet'));
      if ( ! bullets.length ) return;

      const count = bullets.length;
      const swiper = this.swiper;

      const normalize = (n) => ((n % count) + count) % count;

      // Dots are display-only indicators (no click navigation).
      const update = () => {
        const active = normalize(swiper.realIndex);
        bullets.forEach((b, i) => {
          b.classList.toggle('swiper-pagination-bullet-active', i === active);
        });
      };

      swiper.on('realIndexChange', update);
      update();
    }

    destroySlider() {
      if ( this.swiper && typeof this.swiper.destroy === 'function' ) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this._mounted = false;
    }

  }

  if ( typeof customElements.get('square-slider') === 'undefined' ) {
    customElements.define('square-slider', SquareSlider);
  }

  // Re-init inside the theme editor when the section is reloaded.
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('square-slider').forEach((slider) => {
      slider.destroySlider();
      slider.connectedCallback();
    });
  });

  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('square-slider').forEach((slider) => {
      slider.destroySlider();
    });
  });

}
